import { Component, OnDestroy, AfterViewInit, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InterviewDataService } from './services/interview-data.service'
import { HtmlFormatterService } from '../../common/utils/html-formatter.service';
import { DeleteInterviewComponent } from './delete-interview.component';
import { ShareInterviewComponent } from './share-interview.component';
import { RequestFeedbackComponent } from './request-feedback.component';
import { FeedbackSentComponent } from './feedback-sent.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BackendService } from '../../common/services/backend.service';
import { forkJoin } from 'rxjs';

declare var window: any;

@Component({
    selector: 'review-interview',
    templateUrl: './review-interview.component.html',
    standalone: false
})
export class ReviewInterviewComponent implements OnInit, OnDestroy, AfterViewInit {
    attempts: any;
    current: any;
    questions: any;
    question: any;
    interview: any;
    subscription: any;
    menuItems = [];

    constructor(
        public _dataService: InterviewDataService,
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private modalService: NgbModal,
        private backendService: BackendService,
        private _htmlFormatter: HtmlFormatterService
    ) {
        this._dataService.practice = this._activatedRoute.snapshot.queryParamMap.get('practice') || false;
        this._activatedRoute.parent.params.subscribe((params) => this._dataService.interviewId = params['id']);
        this._dataService.attemptId = this._activatedRoute.parent.snapshot.queryParamMap.get('attempt_id');
    }

    ngOnInit(): void {
        this._dataService.loadReviewerSettings();
    }

    ngAfterViewInit() {
        this.loadAllAttempts();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    buildMenuItems() {
        const items = [{label: 'interviews.Delete', action: 'deleteInterview'}];
        if (this.current?.enable_interview_sharing != 0) {
            items.unshift({label: 'interviews.Share', action: 'shareInterview'});
        }
        return items;
    }

    onMenuItemSelected(action: string) {
        switch (action) {
            case 'shareInterview':
                return this.openShareInterviewModal();
            case 'deleteInterview':
                return this.openDeleteModal();
        }
    }

    loadAllAttempts() {
        this._dataService.getInterview();
        this.subscription = this._dataService.interview.subscribe(resp => {
            if (resp) {
                this.interview = resp;
                this.attempts = this.interview.attempts;
                sessionStorage.setItem('tab', (!this.interview.studentInterview) ? 'recommended' : 'list');
                this.attempts.forEach(att => {
                    att.created = this._htmlFormatter.formatTzDate(att.created);
                })
                this.playCurrentAttempt(this._dataService.attemptId);
            }
        });
    }

    playCurrentAttempt(id:any = this._dataService.attemptId){
        this._router.navigate([], {
            relativeTo: this._activatedRoute,
            queryParams: { attempt_id: id},
            queryParamsHandling: 'merge'
        })
        this._dataService.getAttempt(id);
        this._dataService.attempt
            .subscribe((resp:any) => {
                if (resp) {
                    this.current = resp[0];
                    if (this._dataService.practice) {
                        resp[0].questions = resp[0].questions.filter((question) => {
                            return this.interview.questions[0].question_id === question.question_id;
                        })
                    }
                    this.current = resp[0];
                    this.menuItems = this.buildMenuItems();
                }
            });
    }

    currentQuestion(question) {
        setTimeout(() => {
            this.question = question;
        });
    }

    openDeleteModal() {
        let modalRef = this.modalService.open(DeleteInterviewComponent, {container : '.interviews-modal-container'});
        modalRef.componentInstance.id = 'delete';
        modalRef.componentInstance.deleteAttempt.subscribe((attemptId) => {
            this._dataService.deleteInterview(attemptId);
            modalRef.dismiss();
        });
    }

    openRequestFeedbackModal() {
        let modalRef = this.modalService.open(RequestFeedbackComponent, {
            container: '.interviews-modal-container',
            windowClass: 'sm-scrollable'
        });
        modalRef.componentInstance.id = 'feedback';
        modalRef.componentInstance.questions = this.current?.questions || [];
        modalRef.componentInstance.feedbackReq.subscribe(($e) => {
            this._dataService.requestFeedback($e);
            modalRef.dismiss();
            this.modalService.open(FeedbackSentComponent, {container : '.interviews-modal-container'});
        });
    }

    openShareInterviewModal() {
        let modalRef = this.modalService.open(ShareInterviewComponent, {container : '.interviews-modal-container'});
        modalRef.componentInstance.id = 'share';
        modalRef.componentInstance.interviewShared.subscribe(($e) => {
            let attemptObj = <any>{};
            if (window.parent.USER_TYPE == 'student') {
                attemptObj.video_interview_id = this._dataService.interviewId;
                attemptObj.student = window.parent.CURRENT_USER;
                attemptObj.passcode = $e.passcode;
                attemptObj.global_passcode = $e.globalPasscode;
            }
            this._dataService.updateAttempt(attemptObj);
        });
    }
}
